import { GoogleCalendar } from 'datebook';
import moment from 'moment';
import recordFilter from '../components/defaults/filters/record';
import passLockFilter from '../components/defaults/filters/passLockFilter';
  
const GetGoogleCalendar = (event) => {
  let start_raw = moment(event.node.data.agenda_start_time)
  let url = `https://expo10.pnptc.events${passLockFilter(`/agenda/${recordFilter(event.node.recordId)}`, event.node.data.password_protected)}`
  //let ics = 'https://expo10.pnptc.events/calendar-feed/expo10-event-' + event.node.recordId + '.ics'
  let description = `<p><b>This session is part of EXPO 10 (STARTUP AUTOBAHN powered by Plug and Play)</b><br /><a href="https://expo10.pnptc.events">expo10.pnptc.events</a></p><br /> ${event.node.data.agenda_description ?
     event.node.data.agenda_description.childMarkdownRemark.html : null}<br /><p><b>Find out more & join the session at:</b><br /><a href="${url}">${url}</a></p>`

  const options = {
    title: `${event.node.data.agenda_title} | EXPO 10 — STARTUP AUTOBAHN powered by Plug and Play`,
    location: url,
    description: description,
    start: new Date( start_raw.toISOString() ),
    end: new Date( start_raw.add(event.node.data.agenda_duration, 'seconds').toISOString() ),
  }
  
  const googleCalendar = new GoogleCalendar(options)

  return googleCalendar.render()
}

export default GetGoogleCalendar;